import { render, staticRenderFns } from "./DivisionSelector.vue?vue&type=template&id=35834915&"
import script from "./DivisionSelector.vue?vue&type=script&lang=js&"
export * from "./DivisionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports